import PersonBasicInfoModal from './PersonBasicInfoModal';

export default PersonBasicInfoModal;
